import { MerchantDetails } from '@repo/api/endpoints/merchant';

import {
  liberisDefaultPersonData,
  representativeDefaultValues,
} from '@/components/common/helpers/liberis-default-person-data';

import { RequestedLoanValuesWithP24Agreements } from './form.schema';

interface DefaultValues {
  amount: number;
  merchantDetails: MerchantDetails;
}

const defaultValuesCommon = ({ amount, merchantDetails }: DefaultValues) => ({
  amount: amount,
  merchantData: {
    address: {
      street: merchantDetails.address.street,
      postCode: merchantDetails.address.postCode,
      city: merchantDetails.address.city,
      country: merchantDetails.address.country.toUpperCase(),
    },
  },
  agreements: {
    selectAll: false,
    bureau: false,
    liberisMarketing: false,
    payProToLiberisData: false,
    liberisDataToPayPro: false,
  },
  pragmaAgreements: {
    selectAll: false,
    representative: false,
    loanTerms: false,
    pragmaTerms: false,
    bikbig: false,
    marketing: false,
    payProDataProcessing: false,
    pragmaGoDataProcessing: false,
    professionalContract: false,
  },
  ibanId: merchantDetails.bankAccount[0].id.toString(),
  companyRegisterDate: merchantDetails.companyRegisterDate,
  selectAllCheckbox: false,
  email: false,
  sms: false,
  tel: false,
});

export const defaultValuesJdg = ({
  amount,
  merchantDetails,
}: DefaultValues): RequestedLoanValuesWithP24Agreements => {
  const representative = representativeDefaultValues(merchantDetails);

  return {
    ...defaultValuesCommon({
      amount,
      merchantDetails,
    }),
    person: [
      {
        ...representative,
        name: `${merchantDetails.representative[0].name} ${merchantDetails.representative[0].surname}`,
        pesel: merchantDetails.representative[0].pesel,
      },
    ],
  };
};

export const defaultValuesOther = ({
  amount,
  merchantDetails,
}: DefaultValues): RequestedLoanValuesWithP24Agreements => {
  return {
    ...defaultValuesCommon({
      amount,
      merchantDetails,
    }),
    person: liberisDefaultPersonData(merchantDetails),
  };
};
